import { cn } from '@gto/ui/cn'

import type { ModalMediaAlign, ModalMediaWidth } from './modal-block-types'
import { modalMediaLayoutClass } from './modal-media-layout'

type ModalVideoBlockProps = {
  url: string
  centerOnMobile?: boolean
  align?: ModalMediaAlign
  width?: ModalMediaWidth
}

export const ModalVideoBlock = ({ url, align, width, centerOnMobile }: ModalVideoBlockProps) => (
  <video
    autoPlay
    loop
    muted
    playsInline
    src={url}
    className={cn(
      'rounded-sm',
      modalMediaLayoutClass(width, align),
      centerOnMobile === true && 'sm:mx-auto',
    )}
  />
)
